// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3YueA","relation":"styles_relation__xWSiS","type":"styles_type__2CR36","typeCard":"styles_typeCard__1OyH6"};